"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MoreButton =
/*#__PURE__*/
function (_Component) {
  _inherits(MoreButton, _Component);

  function MoreButton() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, MoreButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MoreButton)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "hideMoreOptions", function (event) {
      if (event.target.tagName === "A") {
        event.target.parentNode.parentNode.parentNode.classList.add("hidden");
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "toggleMoreButton", function (event) {
      var target = null;

      if (event.target.tagName === 'I') {
        target = event.target.parentNode;
      } else {
        target = event.target;
      }

      var btnGrp = target.parentNode.parentNode;
      var currentBtn = target.parentNode.childNodes[1];

      if (btnGrp.classList.contains("button-group")) {
        var allButtons = btnGrp.childNodes;

        if (allButtons.length > 0) {
          for (var i = 0; i < allButtons.length; i++) {
            if (allButtons[i].childNodes.length === 2 && !target.parentNode.isSameNode(allButtons[i])) {
              allButtons[i].childNodes[1].classList.add("hidden");
            }
          }
        }
      }

      currentBtn.classList.contains("hidden") ? currentBtn.classList.remove("hidden") : currentBtn.classList.add("hidden");
      currentBtn.style.minWidth = target.offsetWidth + "px";
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getButtonClassName", function () {
      var color = _this.props.isPrimary ? "blue" : "transparent";

      if (_this.props.size === 'regular') {
        return "button button-" + color;
      } else {
        return "button-" + _this.props.size + " button-" + color;
      }
    });

    return _this;
  }

  _createClass(MoreButton, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "".concat(this.props.size, "-more-button")
      }, _react.default.createElement("button", {
        type: "button",
        className: this.getButtonClassName(),
        onClick: this.toggleMoreButton
      }, this.props.title, _react.default.createElement("i", {
        className: "fa fa-angle-down",
        "aria-hidden": "true"
      })), _react.default.createElement("div", {
        className: "more-button-option hidden",
        onClick: this.hideMoreOptions
      }, this.props.children));
    }
  }]);

  return MoreButton;
}(_react.Component);

var _default = MoreButton;
exports.default = _default;